import React from 'react';
import { Grid, Col } from '@bit/knotchinc.web-react-components.grid';
import SummaryTile from '@bit/knotchinc.web-react-components.tiles.summary-tile';
import StoreSync from '@bit/knotchinc.web-react-components.store-sync';
import { numberWithCommas, formatterWithWord } from 'helpers/Utils.js';
import { SectionTitle } from 'components/Global/Title/Title.jsx';
import { ContentBreakdownTile } from 'components/Tiles/';


const TotalContentBreakdownRow = (props) => {
  const { metadata, content, owned } = props;
  const entitiesList = Object.values(metadata);
  const multiEntity = entitiesList.length > 1;

  if (multiEntity) {
    return (
      <React.Fragment>
        <Grid height={234}>
          {entitiesList.map((entity) => (
            <Col centered key={`col-total-content-${entity.public_id}`}>
              <SectionTitle>{owned ? 'Total Owned Content' : 'Total Content'}</SectionTitle>
              <SummaryTile data={content[entity.public_id].data.num_contents} formatter={formatterWithWord('Pieces', numberWithCommas)} isVerticallyAligned={true} />
            </Col>
          ))}
        </Grid>
        <Grid height={210}>
          {entitiesList.map((entity) => (
            <Col centered key={`col-content-breakdown-${entity.public_id}`}>
              <SectionTitle>Content Breakdown</SectionTitle>
              <ContentBreakdownTile entity={content[entity.public_id].data} />
            </Col>
          ))}
        </Grid>
      </React.Fragment>
    );
  }

  const singleEntity = entitiesList[0] && entitiesList[0].public_id && content[entitiesList[0].public_id] ? content[entitiesList[0].public_id] : {};
  const singleEntityData = singleEntity.data;
  const { num_contents, public_id } = singleEntityData;

  return (
    <Grid height={234}>
      <Col centered weight={1}>
        <SectionTitle>{owned ? 'Total Owned Content' : 'Total Content'}</SectionTitle>
        <SummaryTile data={num_contents} formatter={formatterWithWord('Pieces', numberWithCommas)} isVerticallyAligned />
      </Col>
      <Col centered weight={2}>
        <SectionTitle>Content Breakdown</SectionTitle>
        <StoreSync stores={{ entity: singleEntity }}>
          <ContentBreakdownTile entityKey={public_id} />
        </StoreSync>
      </Col>
    </Grid>
  );
};

export default TotalContentBreakdownRow;
